var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-clock"},[_vm._v(" "+_vm._s(_vm.year)+"年"+_vm._s(_vm.month)+"月"+_vm._s(_vm.day)+"日 "+_vm._s(_vm.hour)),_c('span',{staticClass:"divide"},[_vm._v(_vm._s(_vm.divide))]),_vm._v(_vm._s(_vm.min)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }